module.exports = __webpack_public_path__ + "/styles/rotating-plane.css";


//////////////////
// WEBPACK FOOTER
// ./~/react-spinkit/css/rotating-plane.css
// module id = 649
// module chunks = 0